import { SkeletonTable, SkeletonText } from '@dev-spendesk/grapes';
import React from 'react';

export const AnalyticalFieldSkeletonTable = () => (
  <SkeletonTable
    columns={[
      {
        cell: <SkeletonText width="80%" />,
        header: <SkeletonText width="50%" />,
        width: '50%',
      },
      {
        cell: <SkeletonText width="80%" />,
        header: <SkeletonText width="50%" />,
        width: '50%',
      },
    ]}
    withColumnSeparator
    withHeader
    numberOfRows={2}
  />
);
